export const mobileFrameHiddenProps = { smUp: true };
